
import Vue from 'vue';
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import {
    CountryJsonModel,
    EditCountriesRequest,
    factory,
    ResultError,
    SysAdminCountriesClient
} from "@/api-client";
import toasts from "@/components/Toasts";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import {NavigationGuardNext} from "vue-router/types/router";
import {Prop} from "vue-property-decorator";
import ButtonWithConfirm from "@/features/shared/components/ButtonWithConfirm.vue";
import ErrorsSummary from "@/components/ErrorsSummary.vue";

interface Props {
    preloadedModel: CountryJsonModel;
}

@Component({
    components: {
        SectionPageHeading,
        HeadingWave,
        AdministrationDetailviewLayout,
        ButtonWithConfirm,
        ErrorsSummary
    },
    beforeRouteEnter(to, from, next: NavigationGuardNext<EditCountries>) {
        const props = to.meta!.props as Props;
        Promise.all([
            new SysAdminCountriesClient().listJson()
        ]).then(values => {
            props.preloadedModel = values[0]
            next();
        }).catch(e => next(e))
    }
})
export default class EditCountries extends Vue {
    @Prop({required: true})
    preloadedModel!: CountryJsonModel;

    validationError: ResultError = ResultError.createEmpty();

    model = this.preloadedModel;

    async save(dryRun: boolean) {
        this.validationError.clear();
        const postModel = factory.create(EditCountriesRequest);
        postModel.dryRun = dryRun;

        try {
            postModel.countriesJson = JSON.parse(this.model.countriesJson);
        } catch (error) {
            postModel.countriesJson = null;
        }

        await new SysAdminCountriesClient().edit(postModel)
            .then(
                successResponse => {
                    if (!postModel.dryRun) {
                        this.$router.push({ name: 'countries' });
                        toasts.success(this.$ls.Administration_Countries_Toast_Success_CountriesSaved);
                    } else {
                        toasts.success(this.$ls.Administration_Toast_Success_JsonIsValid);
                    }
                },
                (errorResponse: ResultError) => {
                    this.validationError = errorResponse;
                    toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
                });
    }
}
